var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',[_c('a',{staticClass:"text-danger",attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.buttonClicked()}}},[_c('a-icon',{attrs:{"type":"delete"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }